export default __webpack_public_path__ + "static/media/icon-ANALYTICS.c8eb5a58.png";